import { gql } from '@apollo/client';

export const SEND_MESSAGE = gql`
  mutation SendMessage($threadId: ID!, $content: String!) {
    createMessage(input: { messageThreadId: $threadId, content: $content }) {
      message {
        id
      }
      errors
    }
  }
`;
